<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_label_search') || '品牌/颜色/花型/编号/SKU尺寸 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <slot />
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="140px" size="small">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_amzSampleStatus') || '样品状态'"
            >
              <el-checkbox-group v-model="form.listAmzSampleStatus">
                <el-checkbox label="N">
                  {{ $l('form_label_amzSampleStatus_N') || '草稿' }}
                </el-checkbox>
                <el-checkbox label="Y">
                  {{ $l('form_label_amzSampleStatus_Y') || '已审核' }}
                </el-checkbox>
                <el-checkbox label="D">
                  {{ $l('form_label_amzSampleStatus_D') || '已删除' }}
                </el-checkbox>
                <el-checkbox label="T">
                  {{ $l('form_label_amzSampleStatus_T') || '已停用' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_form_label_brand') || '品牌'"
              prop="brandCode"
            >
              <dict-select
                v-model="form.brandCode"
                url="/master/common/dict/spuBrandSelect"
                :placeholder="
                  $l('INDEX.form_label_please_select_brand') || '请选择品牌'
                "
                :selectedLabel.sync="form.brandName"
                clearable
                filterable
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_amz_sample_no') || '样品编号'">
              <el-input v-model.trim="form.amzSampleNo" clearable size="small">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_amz_sample_type') || '样品类型'"
              prop="amzSampleType"
            >
              <dict-select
                v-model="form.amzSampleType"
                :body="{ dictType: 'amzSampleType' }"
                url="/sys/common/dict/system"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                clearable
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_collectionCn') || '中文系列'"
            >
              <dict-select
                v-model="form.collectionNo"
                url="/master/common/dict/biz"
                :placeholder="
                  $l('INDEX.form_placeholder_collectionCn') || '请选择中文系列'
                "
                :body="{ dictType: 'skuCollection' }"
                clearable
                filterable
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_goods_pattern') || '花型'"
              prop="goodsPattern"
            >
              <el-input
                v-model="form.goodsPattern"
                maxlength="50"
                show-word-limit
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_collectionEn') || '英文系列'"
            >
              <dict-select
                v-model="form.collectionNoEn"
                url="/master/common/dict/multilingual"
                :placeholder="
                  $l('INDEX.form_placeholder_collectionEn') || '请选择英文系列'
                "
                :body="{ dictType: 'skuCollection' }"
                :options="{ label: 'labelEn', value: 'value' }"
                clearable
                filterable
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_color') || '颜色'"
              prop="colorCode"
            >
              <el-select
                v-model="form.colorCode"
                collapse-tags
                style="width:100%"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
              >
                <el-option
                  v-for="item in colorOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  class="brand-select"
                >
                  <div style="float: left">
                    <span class="brand-select-item">{{ item.label }}</span>
                    <span
                      class="brand-select-item"
                      style="color: #8492a6; font-size: 13px"
                      >{{ item.brandName }}</span
                    >
                  </div>
                  <span
                    v-if="item.colorCard"
                    class="colorCard"
                    :style="{ background: item.colorCard }"
                  />
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_spu_size') || 'SKU尺寸'">
              <el-input v-model="form.goodsSize" clearable> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_scm') || '工厂'"
              prop="scmCode"
            >
              <dict-select
                v-model="form.scmCode"
                url="/master/common/dict/scmPartners"
                :placeholder="$l('form_placeholder_scm') || '请选择工厂'"
                filterable
                clearable
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_scm_sample_no') || '工厂样品编号'"
              prop="scmSampleNo"
            >
              <el-input
                v-model="form.scmSampleNo"
                maxlength="50"
                show-word-limit
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_remark') || '备注说明'"
              prop="remark"
            >
              <el-input
                v-model="form.remark"
                maxlength="200"
                show-word-limit
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_design') || '企划人员'"
              prop="designCode"
            >
              <dict-select
                v-model="form.designCode"
                :body="userStatusListParams"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('INDEX.form_placeholder_design') || '请选择企划人员'
                "
                :selectedLabel.sync="form.designName"
                clearable
                filterable
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_buyer') || '采购人员'"
              prop="buyerCode"
            >
              <dict-select
                v-model="form.buyerCode"
                url="/master/common/dict/baseUserSelect"
                :selectedLabel.sync="form.buyerName"
                :placeholder="$l('form_placeholder_buyer') || '请选择采购人员'"
                style="width: 100%"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_sample_date') || '样品日期'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginSampleDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endSampleDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('form_label_label_date') || '标签生成日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginLabelDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endLabelDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>

          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.table_label_created_date') || '创建时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginCreateDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endCreateDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.form_label_modification_time') || '修改时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginModifyDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endModifyDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { request } from '@/api/service'

// 初始表单
const initForm = {
  keyword: '',
  listAmzSampleStatus: ['N', 'Y'],
}
export default {
  props: {
    checkedCount: { type: Number, default: 0 },
  },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      userStatusListParams: { userStatusList: ['Y', 'N', 'S'] },
      colorOptions: [],
    }
  },

  mounted() {
    this.query()
    this.getColor()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    getColor() {
      request({
        url: '/ecom/amz/sku/dict/color',
        method: 'post',
        data: { isCustomer: 'N' },
      }).then((res) => {
        this.colorOptions = res.body.data
      })
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
.colorCard {
  float: right;
  margin: 3px 0px 0px 5px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 60px;
  color: #ffffff;
}
</style>
